/**
 * Aucune recette trouvée (ingrédients déjà ajoutés)
 */

import React from "react";
import { motion } from "framer-motion";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";

export default function NoResultsState({ t }) {
  return (
    <motion.div
      className={`${glassPanel} rounded-2xl p-8 sm:p-10 text-center`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="text-5xl mb-4">😕</div>
      <h3 className="text-xl font-bold text-ink-900 dark:text-white mb-2">
        {t("noRecipeFound")}
      </h3>
      <p className="text-ink-600 dark:text-white/80 text-sm">{t("tryAddMore")}</p>
    </motion.div>
  );
}
